module.exports = __webpack_public_path__ + "img/imgs-2.6d81bdab.png";